var React = require('react');

function ItsTimeTriangle1Mobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M87.8438 88.1387L89.9079 18.0687L171.372 91.2588L87.8438 88.1387Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M26.9791 117.376L90.0154 18.0169L87.9213 87.998L26.9791 117.376Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M26.9844 117.377L87.8836 88.0196L171.381 91.2578L26.9844 117.377Z","fill":"#5915C7","key":2})]);
}

ItsTimeTriangle1Mobile.defaultProps = {"width":"128","height":"153","viewBox":"0 0 128 153","fill":"none"};

module.exports = ItsTimeTriangle1Mobile;

ItsTimeTriangle1Mobile.default = ItsTimeTriangle1Mobile;
